'use client';

import type { FC, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface SectionProps extends HTMLAttributes<HTMLElement> {
  header?: ReactNode;
}

export const Section: FC<SectionProps> = ({ children, header, className = '', ...props }) => {
  return (
    <section className={cn('mb-6', className)} {...props}>
      {header && <div className="px-4 py-3 text-sm font-medium text-muted tracking-[0.5px]">{header}</div>}
      <div className="flex flex-col gap-1">{children}</div>
    </section>
  );
};
